import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    alignItems: 'center',
    padding: 48,
    background: theme.palette.grey[200],
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 24
    }
  },
  title: {
    fontSize: 26,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22
    }
  },
  subTitle: {
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    },
    color: theme.palette.grey[600],
    fontWeight: 500
  }
}))

export default useStyles
